// HomeMarinaSelect.jsx
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { InputLabel } from 'container/Reservation/components/ReservationForm/styles';
import { Select } from "../../../components/common";
import { Button } from 'antd/lib/radio';
import { NotFound } from 'container/Agent/Reservation/Submission/Submission.style';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from 'context/GlobalProvider';
import { reservationActions } from 'store/slices/reservation/reservationSlice';
import { generateID, isUnverifiedMarina } from 'library/helpers/utils';

const HomeMarinaSelect = ({ formik, selectedVessel, submitted }) => {
    const { t } = useTranslation();
    const { homeMarinas } = useContext(GlobalContext);
    const dispatch = useDispatch();
    const homeMarinaRef = useRef();
    const [newHomeMarina, setNewHomeMarina] = useState("");
    const [notFound, setNotFound] = useState(false);
    const [options, setOptions] = useState(
        homeMarinas.reduce((obj, { home_marina_id, home_marina_name }) => {
            if (home_marina_id) {
                return {
                    ...obj,
                    [home_marina_id]: home_marina_name
                };
            }
            return obj;

            //Do not add in the list the unverified marinas
            // generateID
            // const id = generateID(home_marina_name);
            // return {
            //     ...obj,
            //     [id]: home_marina_name
            // };
        }, {})
    );

    useEffect(()=>{
        if(selectedVessel?.home_marina_name){
            const newOptions = { ...options };
            newOptions[generateID(selectedVessel.home_marina_name)] = selectedVessel.home_marina_name;
            setOptions(newOptions);
        }
    },[selectedVessel]);

    useEffect(() => {
        if (options[newHomeMarina] || newHomeMarina === "") {
            setNotFound(false);
        } else {
            setNotFound(true);
        }
    }, [newHomeMarina, options]);

    const handleHomeMarinaSetting = (homeMarina) => {
        if (homeMarina) {
            if (!isNaN(parseInt(homeMarina))) {
                dispatch(reservationActions.setHomeMarinaId(homeMarina));
                dispatch(reservationActions.setHomeMarinaName(undefined));
            } else {
                dispatch(reservationActions.setHomeMarinaName(isUnverifiedMarina(homeMarina)? `${homeMarina}`.split('_')[1] : homeMarina ));
                dispatch(reservationActions.setHomeMarinaId(undefined));
            }
        }
    };

    const handleAddNewHomeMarina = newHomeMarina => {
        const newOptions = { ...options };
        newOptions[`_${newHomeMarina}`] = newHomeMarina;
        setNotFound(false);
        setOptions(newOptions);
        setNewHomeMarina(`_${newHomeMarina}`);
        
    };

    const renderHomeMarina = () => {
        const optionsArray = Object.keys(options).map(key => ({
            value: key,
            label: options[key]
        }));

        return (
            <>
                <div className="label-with-status">
                    <InputLabel>
                        {t('HOME_MARINA_LABEL')}
                    </InputLabel>
                </div>
                <Select
                    inputRef={homeMarinaRef}
                    value={formik.values.homeMarinaId}
                    options={optionsArray}
                    onChange={id => {
                        formik.setFieldValue('homeMarinaId', id);
                        setNewHomeMarina(id);
                        handleHomeMarinaSetting(id);
                    }}
                    hint={t('SELECT_MARINA')}
                    error={Boolean(submitted && formik.errors.homeMarinaId)}
                    freeText={true}
                    disabled={Boolean(
                        selectedVessel?.home_marina_verified ||
                        selectedVessel?.home_marina_id ||
                        selectedVessel?.home_marina_name
                    )}
                />
                {notFound && (
                    <NotFound>
                        <span>
                            {t('NO_RESULTS_FOUND_SEARCH_AGAIN_OR_SELECT')}
                        </span>
                        <Button
                            htmlType='button'
                            type='link'
                            onClick={() => handleAddNewHomeMarina(newHomeMarina)}
                        >
                            {t('ADD')}
                        </Button>
                    </NotFound>
                )}
            </>
        );
    };

    return (
       
            renderHomeMarina()
        
    );
};

export default HomeMarinaSelect;
